module.exports = __webpack_public_path__ + "img/commodiousToolbox.833ae179.png";